var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12 14.5C11.5168 14.5 11.125 14.1531 11.125 13.7251L11.125 7.56485C11.125 7.13691 11.5168 6.79 12 6.79C12.4832 6.79 12.875 7.13691 12.875 7.56485L12.875 13.7251C12.875 14.1531 12.4832 14.5 12 14.5ZM10.9565 16.5217C10.9565 15.9454 11.4237 15.4782 12 15.4782C12.5763 15.4782 13.0435 15.9454 13.0435 16.5217C13.0435 17.098 12.5763 17.5652 12 17.5652C11.4237 17.5652 10.9565 17.098 10.9565 16.5217Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidErrorCircle);
export default __webpack_public_path__ + "static/media/solid-error-circle.07af282a18d440813e6d7f4ed1061458.svg";
export { ForwardRef as ReactComponent };